/**
 * Apply Page — `/apply/:inviteId` and `/co-applicant/apply/:inviteId`
 * Renders the verify-info UI (Angular `RegisterComponent` → `signupwithinvite`).
 */
import { VerifyInfoSetPassword } from '@/features/auth/pages/VerifyInfoSetPassword'
import type { ApplyPageProps } from '../types'

export function ApplyPage({ isCoApplicant = false }: ApplyPageProps) {
  return <VerifyInfoSetPassword isCoApplicant={isCoApplicant} />
}
